/** @param {object} m @param {object} handlers */
export function buildMainChatLayoutProps(m, handlers) {
  return {
    showChatThread: m.activePrimaryKey === 'home' && Boolean(m.displayThreadId),
    messages: m.activeMessages,
    onSendMessage: m.activePrimaryKey === 'home' ? handlers.handleSendMessage : undefined,
    chatComposerLocked: m.chatComposerLocked,
    activeThreadId: m.displayThreadId,
    activeQueryVersionByExchangeId: m.activeQueryVersionByExchangeId,
    activeAnswerVersionByExchangeId: m.activeAnswerVersionByExchangeId,
    onSetExchangeActiveQueryVersion: handlers.setExchangeActiveQueryVersion,
    onSetExchangeActiveAnswerVersion: handlers.setExchangeActiveAnswerVersion,
    onSendEditVersion: handlers.handleSendEditVersion,
    onRegenerateAssistantVersion: handlers.handleRegenerateAssistantVersion,
    mainAskBarPrefill: m.mainAskBarPrefill,
    onMainAskBarPrefill: handlers.handleMainAskBarPrefill,
    agentQuestion: handlers.agentQuestion?.activeAgentQuestion ?? null,
    onAgentQuestionConfirm: handlers.agentQuestion?.handleAgentQuestionConfirm,
    onVoiceToggle: handlers.voice?.toggle,
    onHomeVoiceToggle: handlers.startHomeVoice,
    ensureHomeChatId: handlers.ensureHomeChatId,
    onVoiceStop: handlers.voice?.stop,
    voiceActive: handlers.voice?.active ?? false,
    voiceConnecting: handlers.voice?.status === 'connecting',
    voiceError: handlers.voice?.error ?? '',
    voiceSentence: handlers.voice?.sentence ?? '',
    model: m.navThreads.find((thread) => thread.id === m.displayThreadId)?.model ?? 'auto',
    onModelChange: handlers.handleModelChange,
  }
}
